import { createAction, props } from '@ngrx/store';
import { ILoginState } from './login';
import { LoginPayload } from '../../interfaces/login-payload';

export const LOGIN = createAction(
  '[LOGIN] - submit login',
  props<{ body: LoginPayload }>()
);

export const LOGIN_SUCCESS = createAction(
  '[LOGIN] - submit login success',
  props<{ responseLogin: ILoginState }>()
);

export const LOGIN_RESET = createAction(
  '[LOGIN] - reset'
);

export const LOGOUT = createAction(
  '[LOGOUT] - submit logout'
)
